import React, { useState, useEffect, useRef } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import i18next from '../../i18n.js';
import { acceptAdditionalInputFileString, allowedAdditionalFileExtensions, maxFileSize, acceptImageFileString, formModes } from '../../constants.js';
import { getFileAttachmentErrorMessage } from '../helpers/CheckFunctions.js';
import { errorMessageDialog, viewFile, yesNoDialog, viewImage, unknownErrorMessageDialog } from '../ModalDialog.js';
import { getDodumentFiles } from '../helpers/HelperFunctions.js';

const AttachmentsForm = (props) => {
    const [loading, setLoading] = useState(props.value?.length > 0);
    const filesRef = useRef(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        return () => {
            if (filesRef.current) {
                filesRef.current.forEach(file => {
                    window.URL.revokeObjectURL(file.content);
                });
            }
        }
    }, []);

    useEffect(() => {
        const toLoadItems = props.value?.filter(item => !item.file);

        if (toLoadItems?.length > 0) {
            getDodumentFiles('/api/file/GetAttachedFiles', toLoadItems.map(item => {
                return {
                    nodeRef: item.nodeRef
                }
            })).then(result => {
                if (result) {
                    const updatetedFiles = structuredClone(props.value);

                    result.forEach(fileData => {
                        fileData.file.nodeRef = fileData.nodeRef;
                        updatetedFiles.find(item => item.nodeRef === fileData.nodeRef).file = fileData.file;
                    });
                    if (props.onChange) {
                        props.onChange({
                            target: {
                                name: props.name,
                                value: updatetedFiles
                            }
                        });
                    }
                }
                setLoading(false);
            });
        }
        else {
            setLoading(false);
        }
    }, [props.value]);

    const onFileAdded = (e) => {
        e.persist();
        if (e.target.files && e.target.files.length > 0) {
            const errorMessage = getFileAttachmentErrorMessage(e.target.files[0], allowedAdditionalFileExtensions, maxFileSize);
            if (errorMessage) {
                errorMessageDialog(errorMessage);
            }
            else {
                const fileReader = new FileReader();
                fileReader.addEventListener('load', () => {
                    if (props.docId && props.fromMode === formModes.read) {
                        const addedFile = {
                            fileName: e.target.files[0].name,
                            mimeType: e.target.files[0].type,
                            content: fileReader.result.split(';base64,')[1]
                        }
                        fetch('/api/file/AddAttachments', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                documentId: props.docId,
                                attachments: [addedFile]
                            })
                        }).then(async response => {
                            if (response.ok) {
                                const result = await response.json();
                                if (result.documents && result.documents.length > 0) {
                                    const updatetedFiles = props.value ? structuredClone(props.value) : [];
                                    addedFile.content = fileReader.result;
                                    addedFile.nodeRef = result.documents[0].nodeRef;
                                    updatetedFiles.push({
                                        nodeRef: addedFile.nodeRef,
                                        file: addedFile
                                    });
                                    props.onChange({
                                        target: {
                                            name: props.name,
                                            value: updatetedFiles
                                        }
                                    });
                                }
                                else {
                                    unknownErrorMessageDialog();
                                }
                            }
                            else {
                                unknownErrorMessageDialog();
                            }
                        });
                    }
                    else {
                        const updatetedFiles = props.value ? structuredClone(props.value) : [];
                        updatetedFiles.push({
                            file: {
                                fileName: e.target.files[0].name,
                                mimeType: e.target.files[0].type,
                                content: fileReader.result
                            }
                        });
                        props.onChange({
                            target: {
                                name: props.name,
                                value: updatetedFiles
                            }
                        });
                    }
                    fileInputRef.current.value = '';
                }, false);
                fileReader.readAsDataURL(e.target.files[0]);
            }
        }
    }

    const onAddFile = () => {
        fileInputRef.current.click();
    }

    const onLoadFile = (index) => {
        const file = props.value[index].file;
        let anchor = document.createElement("a");
        anchor.href = file.content;
        anchor.download = file.fileName;
        anchor.click();
    }

    const onDeleteFile = (index) => {
        yesNoDialog(i18next.t('document.deleteFileAcception'), i18next.t('document.acceptDeleteFileMessage'), async () => {
            if (props.docData && props.fromMode === formModes.read) {
                fetch(`/api/document/RemoveAdditionalFile?id=${props.docData.docId}&fileNodeRef=${files[index].nodeRef}`, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } })
                    .then((response) => {
                        if (response.ok) {
                            const updatetedFiles = structuredClone(files);
                            window.URL.revokeObjectURL(updatetedFiles[index].content);
                            updatetedFiles.splice(index, 1);
                            setFiles(updatetedFiles);
                        }
                        else {
                            unknownErrorMessageDialog();
                        }
                    });
            }
            else {
                const updatetedFiles = structuredClone(props.value);
                window.URL.revokeObjectURL(updatetedFiles[index].content);
                updatetedFiles.splice(index, 1);
                props.onChange({
                    target: {
                        name: props.name,
                        value: updatetedFiles
                    }
                });
            }
        });
    }

    const onViewFile = (index) => {
        const file = props.value[index].file;
        if (file.mimeType == 'application/pdf') {
            viewFile(file.content, file.fileName, false);
        }
        else {
            viewImage(file.content);
        }
    }

    if (!props.hideTable && loading) {
        return <div className='attachmenst-form'>
            <Spinner animation="border" variant="primary" />
        </div>
    }
    else {
        return <div className='attachmenst-form' id={props.name} >
            {!props.hideTable && (!props.value || props.value.length === 0) && <div className='no-added-label'>{props.noFilesLabel ?? i18next.t('document.attachmentsNotAddedLabel')}</div>}
            {!props.hideTable && props.value?.length > 0 && <div className='attachmenst-list'>
                {props.value.filter(it => it.file).map((item, index) => <div className='attachmenst-item' key={index} >
                    <div className='file-name'>{item.file.fileName}</div>
                    {(item.file.mimeType === 'application/pdf' || acceptImageFileString.split(',').includes(item.file.mimeType)) && <div className='view-btn' onClick={() => onViewFile(index)} />}
                    <div className='load-btn' onClick={() => onLoadFile(index)} />
                    {!props.disabled && <div className='remove-btn' onClick={() => onDeleteFile(index)} />}
                </div>)}
            </div>}
            {!props.disabled && (!props.maxCount || props.maxCount <= 0 || !props.value || props.value.length < props.maxCount) && <Button variant="secondary" className="center add-btn" onClick={onAddFile} >{props.addBtnLabel ?? i18next.t("document.addFile")}</Button>}
            <input ref={fileInputRef} accept={acceptAdditionalInputFileString} onChange={onFileAdded} type="file" style={{ display: "none" }} />
            {props.required && props.submitted && (!props.value || props.value.length === 0) && <div class="help-block">{i18next.t("requiredField")}</div>}
            {props.minCountErrorText && props.required && props.submitted && props.value?.length > 0 && props.value?.length < props.minCount && <div class="help-block">{props.minCountErrorText}</div>}
        </div>
    }
}

export default AttachmentsForm;